<div class="close" (click)="click.emit($event)">
  <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
</div>
